<template>
  <div :class="['header-icon-container', 'h5-header-icon-container', isSelected ? 'header-icon-selected' : '']">
    <div v-if="!isSelected && hasUnreadNotices" class="notice-red-dot"></div>
    <img class="header-icon" src="@assets/svgs/icon-notification.svg" alt="" @click="notificationBarClicked" />
  </div>
</template>
<script lang="ts" setup>
  import { INSTANCE as NotificationManager } from '@/core/Notification/NotificationManager'
  import { computed, onMounted, ref } from 'vue'
  import { useSharedActiveMainHeaderItem, MainHeaderItems } from '@/core/compositions/ActiveMainHeaderItem'

  const { currentSelectedItem, updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()

  const isSelected = computed(() => currentSelectedItem.value === MainHeaderItems.NOTIFICATION_CENTER)

  const hasUnreadNotices = ref<boolean>(false)

  const updateHasUnreadNotices = () => {
    hasUnreadNotices.value = NotificationManager.hasUnreadNotices()
  }

  onMounted(() => {
    updateHasUnreadNotices()
    NotificationManager.addNoticeListener({
      onAdded: () => {
        updateHasUnreadNotices()
      },
      onUpdated: () => {
        updateHasUnreadNotices()
      },
      onRemoved: () => {
        updateHasUnreadNotices()
      },
      onMarkAsRead() {
        updateHasUnreadNotices()
      },
      onRemoveAll() {
        updateHasUnreadNotices()
      },
      onDismiss() {
        // do nothing
      },
    })
  })

  const notificationBarClicked = () => {
    updateCurrentSelectedItem(MainHeaderItems.NOTIFICATION_CENTER)
  }
</script>
<style lang="stylus" scoped>

  .header-icon-container
    rect(32px)
    border-radius 6px
    flex-all-center()
    position relative
    &:hover
      background-color rgba(84, 86, 104, 0.06)
  .header-icon
    rect(20px)
    cursor pointer
    vertical-align super
  .notice-red-dot
    border-radius 3px
    background #e32e27
    rect(6px)
    position absolute
    top 6px
    right 5px
  .header-icon-selected
    background-color rgba(84, 86, 104, 0.06)
    border-radius 6px

  @import '../styles/h5Adaptive/MainHeader.styl'
</style>
